export default {"src":"/_next/static/media/pureagile.e319176c.svg","height":71,"width":59,"blurWidth":0,"blurHeight":0};